import React from 'react';
import Modal, { ModalAction, ModalBody, ModalButton, ModalHeader } from '../../../../../components/Modal/Modal';
import { trans } from '../../../../../localization';
import InputWrapper from '../../../../../components/Common/InputWrapper';
import NowInput from '../../../../../components/Common/NowInput';
import { isEmpty } from '../../../../../utils/utils';

class TableBillCodeAndTotalBillModal extends React.Component {
  state = {
    billNumber: '',
    billCode: '',
    totalBillAmount: null,
  };

  componentDidUpdate(prevProps) {
    const { showingBillCodeAndTotalBillOrder } = this.props;

    if (
      showingBillCodeAndTotalBillOrder !== prevProps.showingBillCodeAndTotalBillOrder &&
      !isEmpty(showingBillCodeAndTotalBillOrder)
    ) {
      const {
        bill_number: billNumber,
        bill_code: billCode,
        total_bill_amount: totalBillAmount,
      } = showingBillCodeAndTotalBillOrder;

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        billNumber,
        billCode,
        totalBillAmount,
      });
    }
  }

  onBillNumberChange = (e) => this.setState({ billNumber: e.target.value });

  onBillCodeChange = (e) => this.setState({ billCode: e.target.value });

  onTotalBillAmountChange = (e) => this.setState({ totalBillAmount: parseInt(e.target.value, 10) });

  onSubmitClick = () => {
    const { billNumber, billCode, totalBillAmount } = this.state;
    const { submitBillCodeAndTotalBill } = this.props;

    submitBillCodeAndTotalBill(billNumber, billCode, totalBillAmount);
  };

  render() {
    const { showingBillCodeAndTotalBillOrder, onClose } = this.props;
    const { billNumber, billCode, totalBillAmount } = this.state;
    const isOpenDialog = !isEmpty(showingBillCodeAndTotalBillOrder);

    return (
      <Modal isOpen={isOpenDialog} width="300px" className="bill-code-and-total-bill-order">
        <ModalHeader>{trans('configure_bill_code_and_total_bill')}</ModalHeader>

        <ModalBody>
          <InputWrapper label={trans('mtn_header_bill_number')} width={150}>
            <NowInput
              value={billNumber}
              onChange={this.onBillNumberChange}
            />
          </InputWrapper>

          <InputWrapper label={trans('mtn_header_bill_code')} width={150}>
            <NowInput
              value={billCode}
              onChange={this.onBillCodeChange}
            />
          </InputWrapper>

          <InputWrapper label={trans('mtn_header_total_bill_amount')} width={150}>
            <NowInput
              value={totalBillAmount}
              onChange={this.onTotalBillAmountChange}
              isNumberFormat
            />
          </InputWrapper>
        </ModalBody>

        <ModalAction>
          <ModalButton type="cancel" onClick={onClose}>
            {trans('mod_go_back')}
          </ModalButton>
          <ModalButton onClick={this.onSubmitClick}>
            {trans('send')}
          </ModalButton>
        </ModalAction>
      </Modal>
    );
  }
}

export default TableBillCodeAndTotalBillModal;


// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/TableReportOrderModal/TableBillCodeAndTotalBillModal.jsx